import { gql } from '@apollo/client'

import { BRAND_CURATION_TASK_DETAILS_FRAGMENT } from '../fragments'

const UPDATE_BRAND_CURATION_TASK_MUTATION = gql`
  mutation updateBrandCurationTask(
    $id: ID!
    $data: BrandCurationTaskUpdateInput!
  ) {
    updateBrandCurationTask(id: $id, data: $data) {
      ...BrandCurationTaskDetailsFragment
    }
  }
  ${BRAND_CURATION_TASK_DETAILS_FRAGMENT}
`

export default UPDATE_BRAND_CURATION_TASK_MUTATION
